import { Loader2, ServerCrash } from "lucide-react";

import { usePortal } from "@/features/portal/portal-context";
import { PopinMark } from "@/components/popin-mark";
import { Button } from "@/components/ui/button";

/**
 * Shown when the user is signed in to Firebase but the pop.in backend GraphQL
 * endpoint is unreachable, so the portal can't load. The session is kept — this
 * is a "come back in a moment" state, not a sign-out.
 */
export function BackendUnavailablePage() {
  const { retryBackend, authChecking, logout } = usePortal();

  return (
    <div className="grid min-h-screen place-items-center bg-background px-6 text-foreground">
      <div className="flex max-w-[440px] flex-col items-center gap-5 text-center">
        <PopinMark size={28} />

        <div className="grid size-14 place-items-center rounded-2xl border border-border bg-card">
          <ServerCrash className="size-7 text-[#f5b945]" />
        </div>

        <div className="space-y-2">
          <h1 className="text-xl font-extrabold tracking-[-.02em]">
            You’re signed in — we just can’t reach the backend
          </h1>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Your session is saved. We can’t load your portal right now because the pop.in
            backend isn’t responding. There’s nothing you need to do — this usually clears up
            on its own. Try again in a moment.
          </p>
        </div>

        <div className="flex items-center gap-2.5 pt-1">
          <Button onClick={retryBackend} disabled={authChecking}>
            {authChecking && <Loader2 className="size-4 animate-spin" />}
            {authChecking ? "Checking…" : "Try again"}
          </Button>
          <Button variant="ghost" onClick={logout}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
